import { ErrorBoundary } from 'react-error-boundary';
import { Toaster } from 'react-hot-toast';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider } from 'antd';
import ErrorPage from './pages/ErrorPage';
import { router } from './routes/router';
import MenuProvider from './shared/context/MenuContext';
import { useCookieSync } from './shared/hooks/useCookieSync';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      throwOnError: true,
      retry: 1,
      staleTime: 0,
    },
  },
});

const theme = {
  token: {
    colorPrimary: '#FF6B00',
    colorInfo: '#FF6B00',
    borderRadius: 8,
  },
  components: {
    Button: {
      colorPrimary: '#FF6B00',
      colorPrimaryHover: '#FF8533',
    },
  },
};

function AppContent() {
  // 쿠키에서 사용자 정보 복원
  useCookieSync();

  return (
    <>
      <RouterProvider router={router} />
      <Toaster position='top-right' />
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MenuProvider>
        <ConfigProvider theme={theme}>
          <AntdApp>
            <ErrorBoundary
              fallback={<ErrorPage />}
              onError={(error) => {
                console.error(error);
              }}
            >
              <AppContent />
            </ErrorBoundary>
          </AntdApp>
        </ConfigProvider>
      </MenuProvider>
    </QueryClientProvider>
  );
}

export default App;
